<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>外管工作台</Breadcrumb-item>
        <Breadcrumb-item>试用期到期提醒</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="rule-bar">
      <span class="rule-dot"></span>
      规则：入职日（首次开课日）起 <b>{{ rules.probationMonths }}</b> 个月为试用期（含延长月数），到期前
      <b>{{ rules.probationNearDays }}</b> 天、<b>{{ rules.probationUrgentDays }}</b> 天各提醒一次；到期日次日转为逾期待处理。
      <a href="javascript:;" @click="$router.push('/hrWorkbench/settings')">调整规则</a>
    </div>
    <div class="filter-bar">
      <span class="toolbar-label">外教运营</span>
      <adviser-select v-model="adviserId" @on-change="onAdviserChange"></adviser-select>
      <Button-group class="seg">
        <Button v-for="item in levelTabs" :key="item.value"
                :type="level === item.value ? 'primary' : 'ghost'"
                @click="changeLevel(item.value)">
          {{ item.label }} {{ counts[item.value] || 0 }}
        </Button>
      </Button-group>
      <span class="toolbar-total">共 {{ dataList.length }} 人</span>
      <Button class="export-btn" @click="exportCsv">导出</Button>
    </div>
    <div class="list-table">
      <Table :columns="columns" :data="dataList" :loading="searchLoading" stripe
             :row-class-name="rowClassName" no-data-text="当前筛选下无记录"></Table>
    </div>
    <probation-decide-modal :value="showDecide" :row="currentRow"
                            @on-close="showDecide = false" @on-success="search"></probation-decide-modal>
    <tch-info-modal :value="showTchInfoModal" :tchId="tchInfoId" @on-close="showTchInfoModal = false"></tch-info-modal>
  </div>
</template>
<script>
import AdviserSelect from './AdviserSelect.vue'
import ProbationDecideModal from './modal/ProbationDecideModal.vue'
import TchInfoModal from '../teacher/modal/TchInfoModal.vue'
import { API_PREFIX, PROBATION_LEVEL, PROBATION_RESULT, codeText, codeColor, tchLabel, adviserParam, downloadCsv, resolveAdviserId, writeStoredAdviserId} from './constants'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
const LEVEL_KEYS = ['open', 'expired', 'urgent', 'near', 'all', 'done']
const SUGGEST = {
  expired: '立即提交转正 / 延长 / 未通过结论',
  urgent: '准备转正评估材料，同步带教反馈',
  near: '关注出勤与课堂质量数据',
  normal: '尚未触发提醒',
  done: '已完成评估，归档',
  missing: '入职日缺失，不进提醒'
}
export default {
  name: 'HrWorkbenchProbation',
  components: { AdviserSelect, ProbationDecideModal, TchInfoModal },
  data () {
    let q = this.$route.query || {}
    return {
      adviserId: resolveAdviserId(q),
      level: LEVEL_KEYS.indexOf(q.level) >= 0 ? q.level : 'open',
      counts: {},
      rules: {},
      dataList: [],
      searchLoading: false,
      rankScoreSeq: 0,
      showDecide: false,
      currentRow: null,
      showTchInfoModal: false,
      tchInfoId: null,
      columns: []
    }
  },
  computed: {
    levelTabs () {
      let r = this.rules
      return [
        { value: 'open', label: '待处理' },
        { value: 'expired', label: '已逾期' },
        { value: 'urgent', label: (r.probationUrgentDays || '—') + ' 天内' },
        { value: 'near', label: (r.probationNearDays || '—') + ' 天内' },
        { value: 'all', label: '全部' },
        { value: 'done', label: '已归档' }
      ]
    }
  },
  created () {
    writeStoredAdviserId(this.adviserId)
    this.$root.$emit('hr-badges-refresh')

    let self = this
    this.columns = [
      {
        title: '外教',
        key: 'tchName',
        width: 200,
        render: (h, params) => self.renderTch(h, params.row)
      },
      {
        title: '外教运营',
        key: 'studyAdviserName',
        width: 140,
        render: (h, params) => h('span', params.row.studyAdviserName || '未分配')
      },
      {
        title: '入职日期',
        key: 'hireDate',
        width: 110,
        render: (h, params) => h('span', params.row.hireDate || '—')
      },
      {
        title: '试用期',
        key: 'probationMonths',
        width: 110,
        render: (h, params) => {
          let row = params.row
          if (row.probationMonths == null) {
            return h('span', '—')
          }
          let text = row.probationMonths + ' 个月'
          if (row.extendMonths) {
            text += '（含延长 ' + row.extendMonths + '）'
          }
          return h('span', text)
        }
      },
      {
        title: '到期日',
        key: 'probationEnd',
        width: 110,
        render: (h, params) => h('span', params.row.probationEnd || '—')
      },
      {
        title: '剩余(天)',
        key: 'daysLeft',
        width: 90,
        align: 'center',
        render: (h, params) => self.renderDays(h, params.row)
      },
      {
        title: '状态',
        key: 'level',
        width: 110,
        render: (h, params) => {
          let row = params.row
          if (row.level === 'done' && row.lastResult) {
            return h('Tag', { props: { color: codeColor(PROBATION_RESULT, row.lastResult) } }, codeText(PROBATION_RESULT, row.lastResult))
          }
          return h('Tag', { props: { color: codeColor(PROBATION_LEVEL, row.level) } }, codeText(PROBATION_LEVEL, row.level) || '—')
        }
      },
      {
        title: '最近结论',
        key: 'lastResult',
        width: 200,
        render: (h, params) => {
          let row = params.row
          if (!row.lastResult) {
            return h('span', { class: 'muted' }, '—')
          }
          return h('div', [
            h('div', codeText(PROBATION_RESULT, row.lastResult) + (row.lastDecidedAt ? ' · ' + row.lastDecidedAt : '')),
            row.lastNote ? h('div', { class: 'muted' }, row.lastNote) : null
          ])
        }
      },
      {
        title: '建议动作',
        key: 'suggest',
        width: 200,
        render: (h, params) => h('span', { class: 'muted' }, SUGGEST[params.row.level] || '')
      },
      {
        title: '操作',
        key: 'action',
        width: 160,
        align: 'center',
        render: (h, params) => self.renderAction(h, params.row)
      }
    ]
  },
  mounted () {
    this.search()
  },
  methods: {
    renderTch (h, row) {
      let self = this
      return h('div', { class: 'tch-cell' }, [
        renderTchNameWithScore(h, {
          text: tchLabel(row),
          score: row.monthRankScore,
          onClick: () => self.openTchInfo(row.tchId)
        }),
        h('div', { class: 'muted' }, 'ID ' + row.tchId + (row.country ? ' · ' + row.country : ''))
      ])
    },
    renderDays (h, row) {
      if (row.daysLeft == null || row.level === 'done' || row.level === 'missing') {
        return h('span', { class: 'muted' }, '—')
      }
      return h('b', { class: row.daysLeft < 0 ? 'text-danger' : '' }, row.daysLeft)
    },
    rowClassName (row) {
      return row.level === 'expired' ? 'row-danger' : ''
    },
    changeLevel (level) {
      this.level = level
      this.search()
    },
    onAdviserChange () {
      writeStoredAdviserId(this.adviserId)
      this.$root.$emit('hr-badges-refresh')
      this.search()
    },
    search () {
      let self = this
      let params = Object.assign({ level: self.level }, adviserParam(self.adviserId))
      self.searchLoading = true
      self.$http.post(API_PREFIX + '/probation/list', params).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.counts = res.data.counts || {}
          self.rules = res.data.rules || {}
          self.dataList = res.data.rows || []
          self.loadMonthRankScores()
        } else {
          self.dataList = []
        }
      }).finally(function () {
        self.searchLoading = false
      })
    },
    loadMonthRankScores () {
      const rows = this.dataList || []
      if (!rows.length) {
        return
      }
      const ids = rows.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, rows, 'tchId', 'monthRankScore', map)
      })
    },
    openDecide (row) {
      this.currentRow = row
      this.showDecide = true
    },
    openTchInfo (tchId) {
      this.tchInfoId = tchId
      this.showTchInfoModal = true
    },
    renderAction (h, row) {
      let self = this
      let nodes = [
        h('Button', {
          props: { size: 'small' },
          on: { click: () => self.openTchInfo(row.tchId) }
        }, '档案')
      ]
      if (row.level !== 'missing') {
        nodes.push(h('Button', {
          props: { type: 'primary', size: 'small' },
          style: { marginLeft: '6px' },
          on: { click: () => self.openDecide(row) }
        }, row.level === 'done' ? '改判' : '处理'))
      }
      return h('div', nodes)
    },
    tchExport (row) {
      return tchLabel(row) + ' ID ' + row.tchId + (row.country ? ' · ' + row.country : '')
    },
    monthsExport (row) {
      if (row.probationMonths == null) {
        return '—'
      }
      let text = row.probationMonths + ' 个月'
      if (row.extendMonths) {
        text += '（含延长 ' + row.extendMonths + '）'
      }
      return text
    },
    daysExport (row) {
      if (row.daysLeft == null || row.level === 'done' || row.level === 'missing') {
        return '—'
      }
      return row.daysLeft
    },
    statusExport (row) {
      if (row.level === 'done' && row.lastResult) {
        return codeText(PROBATION_RESULT, row.lastResult)
      }
      return codeText(PROBATION_LEVEL, row.level) || '—'
    },
    lastExport (row) {
      if (!row.lastResult) {
        return '—'
      }
      let text = codeText(PROBATION_RESULT, row.lastResult) + (row.lastDecidedAt ? ' · ' + row.lastDecidedAt : '')
      if (row.lastNote) {
        text += ' ' + row.lastNote
      }
      return text
    },
    actionExport (row) {
      if (row.level === 'missing') {
        return '档案'
      }
      return '档案 ' + (row.level === 'done' ? '改判' : '处理')
    },
    exportCsv () {
      if (!this.dataList.length) {
        this.$Message.warning('没有可导出的数据')
        return
      }
      let self = this
      let rows = this.dataList.map(function (row) {
        return [
          self.tchExport(row),
          row.studyAdviserName || '未分配',
          row.hireDate || '—',
          self.monthsExport(row),
          row.probationEnd || '—',
          self.daysExport(row),
          self.statusExport(row),
          self.lastExport(row),
          SUGGEST[row.level] || '',
          self.actionExport(row)
        ]
      })
      downloadCsv('试用期到期提醒.csv', ['外教', '外教运营', '入职日期', '试用期', '到期日', '剩余(天)', '状态', '最近结论', '建议动作', '操作'], rows)
    }
  }
}
</script>
<style scoped lang="less">
.rule-bar {
  margin: 8px 0 12px;
  padding: 8px 12px;
  background: #f8f8f9;
  border-radius: 4px;
  line-height: 22px;
  font-size: 12px;
  color: #495060;
}
.rule-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 4px;
  border-radius: 50%;
  background: #2d8cf0;
}
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}
.toolbar-label {
  color: #495060;
}
.toolbar-total {
  color: #80848f;
  font-size: 12px;
}
.export-btn {
  margin-left: auto;
}
.list-table /deep/ .muted {
  color: #80848f;
  font-size: 12px;
}
.list-table /deep/ .text-danger {
  color: #E6464E;
}
.list-table /deep/ .tch-cell {
  padding: 4px 0;
}
.list-table /deep/ .ivu-table .row-danger td {
  background: #fff5f5;
}
</style>



// WEBPACK FOOTER //
// HrWorkbenchProbation.vue?06943892